// src/components/Profile/avatarMapping.js
import blue1 from '../../../Assets/avatars/blue1.webp';
import blue2 from '../../../Assets/avatars/blue2.webp';
import blue3 from '../../../Assets/avatars/blue3.webp';
import red1 from '../../../Assets/avatars/red1.webp';
import red2 from '../../../Assets/avatars/red2.webp';
import red3 from '../../../Assets/avatars/red3.webp';
import green1 from '../../../Assets/avatars/green1.webp';
import green2 from '../../../Assets/avatars/green2.webp';
import green3 from '../../../Assets/avatars/green3.webp';

export const avatarMapping = {
  blue1,
  blue2,
  blue3,
  red1,
  red2,
  red3,
  green1,
  green2,
  green3,
};

export const defaultAvatar = blue1;
